export default {
    wbl: {
        cat_list: "White/Black List Category",
        create: "Create your White Black List",
        id: "Id",
        list: "WBL List",
        title: "White/Black List",
        update: "Update your White Black List",
        value_list: "Value List",
        wbl_category: "White/Black list Category",
      }
}